import React from 'react';
import { useTranslation } from 'react-i18next';
import './ChooserEntry.css';

/**
 * ChooserEntry — J2's "We can help you choose" secondary entry (#1921).
 *
 * ENTRY STUB ONLY, per the #1921 scope note: the chooser itself (the
 * question flow the mockup calls "A's Navigator") is #1922, Wave 2, and is
 * NOT built here. This component is exported per the #1921 blocking
 * precondition so #1923's learner-home variant can reuse the same entry
 * affordance once #1922 gives it something real to open — it is
 * deliberately just a labelled button; the container decides what it does
 * (today: navigate to a minimal placeholder route, never a dead link).
 */
function ChooserEntry({ onClick }) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className="gd-chooser-entry"
      data-testid="gd-chooser-entry"
      onClick={onClick}
    >
      <span>{t('scenarios.helpYouChoose', 'Help you choose')}</span>
      <span className="gd-chooser-entry__hint">{t('scenarios.helpYouChooseHint', 'Answer three quick questions')}</span>
    </button>
  );
}

export default ChooserEntry;
